import React from "react";
import { Navigate, matchPath, useLocation } from "react-router-dom";

export function RequireAuth({ children, auth }) {
    let location = useLocation();

    if (!auth) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}

export function matchWithEmptyPath(path) {
    return matchPath(
        {
            path: "/",
            exact: true,
        },
        path
    );
}
export function matchWith(pathname, path) {
    return matchPath(
        {
            path,
            exact: true,
        },
        pathname
    );
}

export const Paths = {
    LOGIN: "/login",
    LOGINSSORETURN: "/ssoreturn",
    LOGOUT: "/logout",
    ADVERTISING: "/advertising",
    ADVERTISING_FORM: "/advertising/:id",
    FILM: "/film",
    CONTACT: "/contact",
    PROFILE: "/profile",
    REPORT: "/report",
    ADV_REPORT: "/report/advertising",
    LOG_REPORT: "/report/log",
    STATISTICS: "/statistics",
    STATISTICS_TAGS: "/statistics/tags",
    STATISTICS_USER: "/statistics/user",
    STATISTICS_CATEGORIES: "/statistics/categories",
    ADMIN: "/admin",
    ADMIN_API_IMPORT: "/admin/import",
    ADMIN_TAGS: "/admin/tags",
    ADMIN_TEMPLATES: "/admin/templates",
    ADMIN_USER: "/admin/user",
    ADMIN_USER_EDIT: "/admin/user/:id",
};
export function isValidPath() {}
export const Menu = [
    {
        label: "Advertising",
        pathname: Paths.ADVERTISING,
    },
    {
        label: "Film Releases",
        pathname: Paths.FILM,
    },
    {
        label: "Contact",
        pathname: "/contact",
    },
    {
        label: "Reports",
        pathname: null,
        submenu: [
            {
                label: "Advertising Report",
                pathname: Paths.ADV_REPORT,
            },
            {
                label: "Log Sheet Report",
                pathname: Paths.LOG_REPORT,
            },
        ],
    },
    {
        label: "Statistics",
        pathname: null,
        submenu: [
            {
                label: "Reviews",
                pathname:Paths.STATISTICS_USER,
            },
            {
                label: "Tags",
                pathname: Paths.STATISTICS_TAGS
            },
            {
                label: "Rating Categories",
                pathname: Paths.STATISTICS_CATEGORIES
            }
        ],
    },
    {
        label: "Admin",
        pathname: null,
        submenu: [
            {
                label: "Tags",
                pathname: Paths.ADMIN_TAGS,
            },
            {
                label: "Api Import",
                pathname: Paths.ADMIN_API_IMPORT,
            },
            {
                label: "Templates",
                pathname: Paths.ADMIN_TEMPLATES,
            },
            {
                label: "User Management",
                pathname: Paths.ADMIN_USER,
            },
        ],
    },
];
